import React from 'react';

/**
 * PROPS
 * value = string
 * label = string
 * onChange(value) = func
 */

const EventDate = props => {
  return (
    <React.Fragment>
      <React.Fragment>
        <label className="inp inp--date">
          <div className="inp-icon">
            <img
              className=""
              src="../../../static/img/icons/i-calendar.svg"
              alt=""
              height="18"
              width="18"
            />
          </div>
          <input autoComplete="off"
            className="inp__field"
            type="text"
            value={props.value}
            onChange={e => props.onChange(e.target.value)}
          />
        </label>
      </React.Fragment>
    </React.Fragment>
  );
};

export default EventDate;
